import { storage } from "../../../exports/storage";
import { on } from "../../event/head";
import { events } from "../../../exports/event-q-bus";
import type { DeviceEvents } from "./events";
import type { OttoNexus } from "../../nexus";

/**
 *
 *
 */
const pointerEventName = "mousemove";

const storageKey = "isHybrid";

/*                                                                                                   */
const minMovesForSuccess = 3;

/*                                                                                 */
const maxTimeForSuccess = 300;

/**
 *
 *
 *
 */
export const detectionData = {
  /*                                                                     */
  moves: 0,
  /*                                              */
  timeout: undefined as number | undefined,
};

/**
 *
 *
 *
 *
 *
 *
 */
export function isTouchable(): boolean {
  const data = ["ontouchstart" in window, !!navigator.maxTouchPoints] as const;

  const isTouchableFlag = data.some(Boolean);
  return isTouchableFlag;
}

/**
 *
 *
 *
 */
export function detectionTimeoutCalback(this: OttoNexus["device"]["pointerType"]): void {
  /*                                                                                                                               */
  if (detectionData.moves >= minMovesForSuccess) {
    /*                                                                                                               */
    this.set({ isTouchable: true, isHybrid: true, isMouse: true });
    /*                                                                  */
    storage(() => window.sessionStorage).setItem(storageKey, "true");

    /*                                                                       */
    return;
  }

  /*                                             */
  detectionData.moves = 0;
}

/**
 *
 *
 *
 *
 *
 */
export function detectionEventCallback(this: () => void): void {
  /*                                                                                    */
  /*                                                   */
  /*                                                                                                                    */
  /*                                                                                     */
  /*                                                                                                                                   */
  if (detectionData.timeout) window.clearTimeout(detectionData.timeout);
  detectionData.timeout = window.setTimeout(this, maxTimeForSuccess);

  /*                                               */
  /*                                                                                  */
  detectionData.moves++;
}

/**
 *
 *
 *
 *
 *
 *
 */
export const detectPointerType = ({ pointerType: signal }: OttoNexus["device"]): void => {
  if (import.meta.env.SSR) return;

  /*                                              */
  if (!isTouchable()) {
    signal.set({ isTouchable: false, isHybrid: false, isMouse: true });
    return;
  }

  /*                                                                                                        */
  const store = storage(() => window.sessionStorage);
  if (store.getItem(storageKey) === "true") {
    signal.set({ isTouchable: true, isHybrid: true, isMouse: true });
    return;
  }

  /*                                                          */
  const unset = on(
    document.documentElement,
    pointerEventName,
    detectionEventCallback.bind(detectionTimeoutCalback.bind(signal)),
  );

  /*                                                                  */
  /*                                                                   */
  signal.set({ isTouchable: true, isHybrid: false, isMouse: false });

  /*                                                                  */
  signal.sub(({ isMouse }) => {
    if (isMouse) unset();
  });
};

/**
 *
 *
 */
export const initPointerTypeFlagging = ({ pointerType: signal }: OttoNexus["device"]): void => {
  if (import.meta.env.SSR) return;

  /*                                                                                           */
  const qbus = events<DeviceEvents>();
  signal.sub((e) => {
    const { classList } = document.documentElement;

    if (e.isTouchable) {
      /*                                                                        */
      classList.add("touchable");
      /*                   */

      qbus.emitRetain("assets.device.touchable.detected");
    } else {
      classList.add("not-touchable");
    }

    if (e.isHybrid) {
      /*                                                                */
      classList.add("touchable-hybrid");
      /*                   */
      qbus.emitRetain("assets.device.hybrid.detected");
    }
  });
};
